import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import { SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT } from '@softapps/allgemein/utils';
import { provideSearchModule } from '@softapps/core';
import { ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { map, Observable, of } from 'rxjs';
import { default as de } from '../i18n/de.json';
import { TicketAccountContextEditorComponent } from './components/ticket-account-context-editor/ticket-account-context-editor.component';
import { TicketSearchResult } from './components/ticket-search-result/ticket-search-result';
import { Ticket } from './data/ticket.model';
import { TicketSearchService } from './services/ticket-search.service';
import { SOFTLINE_PERMISSION_TICKET } from './ticket.shared';
import { ticketRoutes } from './ticket.routes';
import { provideTicketGlobals } from './ticket.globals';

export function provideTicketModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'ticket',
        title: '#TICKETS/PUBLIC.APP',
        icon: 'fa-regular fa-clipboard-list-check',
        route: '/ticket',
        color: 'bg-[#CAEBFF] text-black',
        permission: SOFTLINE_PERMISSION_TICKET,
      },
      withSoftAppsModuleRoutes({ app: ticketRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/softline/ticket',
        description:
          'Softline-Ticketsystem: Tickets erfassen, bearbeiten und kommentieren.',
      })
    ),
    ...provideTicketGlobals(),
  ];
}

export const ticketProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'ticket',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#TICKETS/PUBLIC.APP',
      icon: 'fa-regular fa-clipboard-list-check',
      route: '/ticket',
      color: 'bg-[#CAEBFF] text-black',
      permission: SOFTLINE_PERMISSION_TICKET,
    });
  }),
  {
    provide: SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT,
    useValue: TicketAccountContextEditorComponent,
    multi: true,
  },
  provideSearchModule<Ticket>({
    url: '/ticket',
    category: 'Ticket',
    icon: 'fa-regular fa-comment',
    permission: SOFTLINE_PERMISSION_TICKET,
    component: TicketSearchResult,
    factory: () => {
      const service = inject(TicketSearchService);
      return {
        results(term: string | null): Observable<Ticket[]> {
          if (!term || term.length != 6) {
            return of([]);
          }
          return service
            .search(term)
            .pipe(
              map((tickets) => tickets.filter((t) => t.id.toString().startsWith(term)))
            );
        },
      };
    },
  }),
];
